<template>
  <div class="cat_020Notificadores">
    <div class="form-control">
      <div v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
        <select v-bind:id="idDelInput" v-model="idDelModelo" @change="cambiarDatos($event)" class="form-control">
          <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de notificador</option>
          <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los notificadores</option>        
          <option v-for="(notificador,index) in notificadores" :value="notificador.NotificadorId" :key="index">{{obtenerNombreCompleto(notificador)}}</option>
        </select>      
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        notificadores: [],
        idDelModelo:null
      }
    },
    props: {            
      parametros:Object,
      valorDefinido:Number,
      idDelInput:String,      
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      filtrarPorJurisdiccion: {
          type: Boolean,
          default: false
      },
      listaDeNotificadores: {
          type: Array,
          default: () => []
      }
    },
    computed:{
      
    },
    methods: {
      /**
       * Metodo para asignar la llave del elmento seleccionado del catalogo 020Notificadores
       * @param {object} evento [evento emitido por el select]
       */
      cambiarDatos(evento){
        this.idDelModelo = evento.target.value;
        const valoresDelCatalogo =
        {
          llave: this.idDelInput,
          valor: evento.target.value 
        }
        let notificadorObj = this.obtenerNotificadorObj(evento.target.value);
        this.$store.dispatch("A_SINOJ_Catalogos_establecer020Notificadores",valoresDelCatalogo);
        this.$emit("valorParaElPadre",evento,notificadorObj);
      },
      obtenerNotificadorObj: function(notificadorId) {
        let id = parseInt(notificadorId);
        let notificador = null;
        this.notificadores.filter(nBD => nBD.NotificadorId == id).forEach(n => {notificador = n});
        return notificador;
      },
      obtenerNombreCompleto: function(notificador) {
        let nombres = [notificador.Usuario.Nombre, notificador.Usuario.ApellidoPaterno, notificador.Usuario.ApellidoMaterno]
        const NOMBRE_COMPLETO = nombres.join(' ');
        return NOMBRE_COMPLETO;
      },
      /**
       * Metodo para llenar catalogo 020Notificadores mediante el llamado de la API
       */
      cargarNotificadores: function() {
        // definimos metodo de API
        const SERVIDOR = api.conexion;
        const METODO_API = api.SINOJ.catalogos.C020TiposNotificadores;
        let urlApi = SERVIDOR + METODO_API;
        // creamos la peticion con el formulario
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {};
        
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        this.parametros.ConAreaDeUsuario = this.filtrarPorJurisdiccion;
        let peticionMetodoGetZonasAPI = this.parametros;
        // contruir header de la peticion
        let peticionArchivos = false;
        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
        comun.SeEstaCargandoInformacion(true);
        axios.post(urlApi, peticionMetodoGetZonasAPI, headerPeticion)
                .then(respuesta => {            
                    if (respuesta.data.SiHayError) {
                        console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    } else {
                        this.notificadores = respuesta.data.Notificadores;
                    }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
                }
        ) // axios.post
      }
    }, 
    mounted(){
      // establecer valor default
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

        const valoresDelCatalogo = {
          llave: this.idDelInput,
          valor: this.idDelModelo
        }
      this.$store.dispatch("A_SINOJ_Catalogos_establecer020Notificadores", valoresDelCatalogo);
    },
    created() { debugger
      if(this.listaDeNotificadores != undefined && this.listaDeNotificadores != null && this.listaDeNotificadores.length > 0)
        this.notificadores = this.listaDeNotificadores;
      else
        this.cargarNotificadores();
    }
  }
</script>
<style scoped>

</style>
<style>
.cat_020Notificadores .form-control {
    background-color: white !important;
    color: black !important;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C020Notificadores.vue